module.exports = __webpack_public_path__ + "static/assets/3b48c179813bc660cf62f1651c9f72e8.png";